'use client'
import { useRouter } from 'next/router'

import { Modal, ModalBody, ModalContent } from '@nextui-org/react'

import { useStore } from '@nanostores/react'
import { GoogleLoginButton } from 'website/src/components/GoogleLogin'
import { atoms } from 'website/src/lib/atoms'
import {
    demoProjectDataCookie as demoProjectFilesCookie,
    env,
} from 'website/src/lib/env'
import { createLoginRedirectUrl } from 'website/src/lib/utils'
import { useRootProps } from 'website/src/lib/hooks'
import { getMarkdown, pagesTreeBfs } from 'website/src/lib/editor-utils'
import { DemoProjectFiles } from 'website/src/lib/onboarding'
import { PagesTree } from 'db/types'

const storeDemoDocsInCookie = (pagesTree: PagesTree[]) => {
    const persistence = atoms.docPersistence.get()
    if (!persistence) throw new Error('No persistence found')
    const nodes = pagesTreeBfs(pagesTree, (page) => {
        return false
    }).filter((x) => x.pageId)

    const files: DemoProjectFiles = nodes.map((node) => {
        const content = localStorage.getItem(node.pageId!) || null
        return {
            content,
            pageSlug: node.slug!,
        }
    })
    // console.log('files', JSON.stringify(files, null, 2))
    const cookie = encodeURIComponent(JSON.stringify(files))
    document.cookie = `${demoProjectFilesCookie}=${cookie};path=/;`
}

export function EditorProjectSignupModal({}) {
    const isOpen = useStore(atoms.showSignupModal)
    const router = useRouter()
    const redirectTo = new URL(router.asPath, env.NEXT_PUBLIC_URL)
    const { pagesTree, projectType } = useRootProps()

    return (
        <Modal
            backdrop='opaque'
            size='2xl'
            className=''
            isOpen={isOpen}
            onOpenChange={(isOpen) => {
                atoms.showSignupModal.set(isOpen)
            }}
        >
            <ModalContent className='flex !py-12 items-center flex-col gap-4'>
                <div className='flex flex-col text-center gap-1 text-lg font-semibold'>
                    Sign up to Holocron
                </div>
                <div className='max-w-[400px] text-center opacity-70 font-medium'>
                    To save your work, sign up with Google. You can also use
                    features like sync with Github and more
                </div>

                <ModalBody>
                    <GoogleLoginButton
                        onClick={() => {
                            if (projectType === 'demo-project') {
                                storeDemoDocsInCookie(pagesTree)
                                return
                            }
                            return
                        }}
                        callbackUrl={createLoginRedirectUrl({
                            redirectTo: redirectTo.toString(),
                            signupReason: projectType,
                        })}
                    />
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}
